module.exports = __webpack_public_path__ + "img/share.877ded9c.svg";